import { CustomerChatSenderType } from '@orcar/common';
import { motion } from 'framer-motion';
import MobiIcon from '@/assets/mobi_icon.svg';
import { cn } from '@/utils/cn';
import LoadingDotsFramer from './LoadingDots';

const Bubble = ({
  userText,
  time,
  senderType,
  isLoadingMode,
  isSure,
}: {
  userText: string;
  time: string;
  senderType: CustomerChatSenderType;
  isLoadingMode?: boolean;
  isSure?: boolean;
}) => {
  const isMobi = senderType === CustomerChatSenderType.AI_AGENT;
  const isHuman = senderType === CustomerChatSenderType.MANAGER;
  const isAgent = isMobi || isHuman;
  const isCustomer = senderType === CustomerChatSenderType.CUSTOMER;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className={cn('flex w-full', isCustomer && 'justify-end')}>
        <div
          className={cn(
            'flex items-end gap-1',
            isCustomer && 'flex-row-reverse',
          )}
        >
          {/* 버블 */}
          <div
            className={cn(
              'bg-mobi-gradient flex max-w-[520px] flex-col gap-1 rounded-s p-4',
              {
                'max-w-[280px]': isSure,
                'bg-primary-090': isCustomer && !isSure,
                'bg-sure-090': isCustomer && isSure,
                'bg-mobi-gradient': isAgent && !isSure,
                'bg-sure-gradient': isAgent && isSure,
              },
            )}
          >
            {isAgent && (
              <div className='flex gap-1'>
                {isMobi && <img src={MobiIcon} width={12} height={12} />}
                <p className='text-caption2 text-grey-050 '>
                  {isMobi ? 'MOBI · AI Agent' : `Wan · Orcar Rental`}
                </p>
              </div>
            )}
            <p
              className={cn('whitespace-pre-line text-body2 tracking-l', {
                'text-grey-000': isCustomer,
                'text-grey-070': isAgent,
                'text-grey-050': isLoadingMode,
              })}
            >
              {userText}
            </p>
            {isLoadingMode && (
              <div className='relative flex h-5 items-center gap-1'>
                <LoadingDotsFramer />
              </div>
            )}
          </div>
          {/* 시간 */}
          <p className='text-caption2 tracking-xl text-grey-050'>{time}</p>
        </div>
      </div>
    </motion.div>
  );
};

export default Bubble;
